module.exports = "https://web-assets.ifttt.com/packs/media/partners/test-green-5069c1b9.svg";